/**
 * Created by 产品部 王东东 on 2019/3/4.
 */
const management = () => import('./management');
const edit = () => import('./edit.vue');

const memberRouter = [
  {
    path: '/member/management', name: 'management', component: management, meta: { c: 'member', a: 'management' }
  },
  {
    path: '/member/edit', name: 'edit', component: edit, meta: { c: 'member', a: 'edit' }
  },
];

export default memberRouter;

